<template>
  <div class="view-container">
    <div class="card">
      <div class="card-content">
        Are you sure you want to logout?
      </div>
      <div class="card-footer">
        <a class="card-footer-item" @click="onCancelClicked">Cancel</a>
        <a class="card-footer-item" @click="onLogoutClicked">Logout</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobile: "",
      password: ""
    };
  },
  methods: {
    onCancelClicked() {
      let component = this;
      component.$store.commit("setNavVisible", true);
      component.$router.go(-1);
    },
    onLogoutClicked() {
      let component = this;
      localStorage.clear();
      component.$router.push("/login");
    }
  },
  mounted() {
    let component = this;
    component.$store.commit("setNavVisible", false);
  }
};
</script>
<style lang="scss" scoped>
.view-container {
  height: 100%;
  background: $grey-lighter;
  .card {
    width: 400px;
    margin: auto;
    top: 50%;
    margin-top: -150px;
  }
}
</style>
